import { render, staticRenderFns } from "./RuleAction.vue?vue&type=template&id=67711b5d&scoped=true&"
import script from "./RuleAction.vue?vue&type=script&lang=js&"
export * from "./RuleAction.vue?vue&type=script&lang=js&"
import style0 from "./RuleAction.vue?vue&type=style&index=0&id=67711b5d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67711b5d",
  null
  
)

export default component.exports